// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.lang-switcher[data-v-03bb1a09] {
	position: fixed;
	top: 10px;
	right: 10px;
	display: inline-flex;
	gap: 6px;
	z-index: 1000;
}
.lang-btn[data-v-03bb1a09] {
	background: rgba(15, 23, 42, 0.7);
	color: #e5e7eb;
	border: 1px solid rgba(148, 163, 184, 0.35);
	border-radius: 999px;
	padding: 4px 8px;
	font-size: 12px;
	cursor: pointer;
}
.lang-btn.active[data-v-03bb1a09] {
	background: rgba(139,92,246,0.95);
	border-color: rgba(139,92,246,0.6);
	color: white;
	font-weight: 700;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
